const footerLinks = {
  '快速导航': [
    { label: '热门话题', href: '#topics' },
    { label: '人气排行', href: '#ranking' },
    { label: '专题合集', href: '#index' },
    { label: '精选推荐', href: '#media' },
  ],
  '影视分类': [
    { label: '最新电影', href: '#topics' },
    { label: '热门剧集', href: '#topics' },
    { label: '综艺娱乐', href: '#topics' },
    { label: '动漫番剧', href: '#topics' },
  ],
  '帮助中心': [
    { label: '常见问题', href: '#faq' },
    { label: '联系我们', href: '#contact' },
    { label: '最新动态', href: '#updates' },
    { label: '关于我们', href: '#about' },
  ],
  '合作伙伴': [],
};

export default function Footer() {
  const handleClick = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={handleClick('#hero')}
              className="flex items-center gap-2 mb-4 cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
                嫩
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                嫩草视频
              </span>
            </a>
            <p className="text-xs leading-relaxed font-label text-background-400">
              嫩草视频手机网页版，整合97视频、丝瓜视频、蓝莓视频、91在线视频等高清影视资源。无需下载APP，即开即看，电影电视剧不卡顿高清流畅播放。
            </p>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                {title}
              </h4>
              {links.length > 0 ? (
                <ul className="space-y-2">
                  {links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={handleClick(link.href)}
                        className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200 font-label cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-xs text-background-500 font-label">
                  即将上线，敬请期待
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500 font-label">
              &copy; 2026 嫩草视频 nencao-video.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500 font-label">网页版观影，无需下载</span>
              <span className="text-xs text-background-500 font-label">高清流畅 · 即点即看</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}